enum RollupFilterRule {
    TextEquals = 1,
    TextEmpty = 2,
    LogicalTrue = 3,
    LogicalFalse = 4,
    LogicalIndeterminate = 5,
    NumberEquals = 6,
    NumberMore = 7,
    NumberLess = 8,
    NumberBetween = 9,
    NumberEmpty = 10,
    LinkedEquals = 11,
    LinkedEmpty = 12
}

export default RollupFilterRule;